import { createFileRoute } from '@tanstack/react-router';

import { ensureProjectMediaQueryData } from '@/api/media';
import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media'
)({
  loader: ensureProjectMediaQueryData,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="media" /> },
});
